import { MenuItem } from "@mui/material";
import { useState } from "react";

import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import { IInfoReasonComponent } from "@/main/screens/order/viewOrder/components/infoOrder/typesInfoOrder";
import ModalReason from "@/main/screens/order/viewOrder/components/modalReason/modalReason";
import { Controls } from "@/main/services/constants/constantsControl";
import { OrderStatusEnum } from "@/main/services/enum/OrderStatusEnum";
import { ReasonTypeEnum } from "@/main/services/enum/ReasonEnum";
import { getTranslateByKey } from "@/main/services/utils";

import { useThreeDotsPartClaimContext } from "../context";
import OptionEmptySearchClaim from "../optionEmptySearchClaim";
import useKogControlElementId from "@/main/hooks/useKogControlElementId";

interface IOptionCancelPartSearchClaimProps {
	idStatus: number;
	guidProcurement: string;
	guidProcurementSupplier: string;
	guidProcurementSupplierItem: string;
	isStripePayment: boolean;
	deliveryBySupplier: boolean;
	cancelationPending: boolean;
	refreshGrid: () => void;
}
function OptionCancelPartSearchClaim({
	idStatus,
	isStripePayment,
	guidProcurementSupplierItem,
	guidProcurement,
	guidProcurementSupplier,
	deliveryBySupplier,
	cancelationPending,
	refreshGrid,
}: IOptionCancelPartSearchClaimProps) {
	const { generateIdMenu, closeThreeDotsPartClaim } = useThreeDotsPartClaimContext();
	const showButtonCancelControl = useKogControlElementId(Controls.IdCancelPart);

	const INITIAL_INFO_REASON: IInfoReasonComponent = {
		guidSupplierItem: null,
		idReasonType: null,
		titleModal: null,
		open: false,
		guidProcurement: null,
		guidProcurementSupplier: null,
		idProcurementStatusCompany: null,
		deliveryBySupplier: false,
	};

	const [infoReasonComponent, setInfoReasonComponent] = useState<IInfoReasonComponent>(INITIAL_INFO_REASON);
	const [openModalReason, setOpenModalReason] = useState<boolean>(false);

	const showButtonCancel =
		showButtonCancelControl &&
		(idStatus === OrderStatusEnum.Assigned || (idStatus === OrderStatusEnum.Transit && !cancelationPending)) &&
		!isStripePayment;

	function handleCancelPart() {
		setInfoReasonComponent({
			guidSupplierItem: guidProcurementSupplierItem,
			open: true,
			titleModal: getTranslateByKey("information.cancelPart"),
			idReasonType: ReasonTypeEnum.Cancel,
			guidProcurement,
			guidProcurementSupplier,
			idProcurementStatusCompany: idStatus,
			deliveryBySupplier: deliveryBySupplier,
		});

		setOpenModalReason(true);
		closeThreeDotsPartClaim();
	}

	if (!showButtonCancel) return <OptionEmptySearchClaim option="OptionCancel" />;
	return (
		<>
			<MenuItem id={generateIdMenu("cancel-part")} onClick={handleCancelPart}>
				{getTranslateByKey("information.cancel")}
			</MenuItem>
			{infoReasonComponent.open && (
				<KogModalFadeComponent open={openModalReason} setOpen={setOpenModalReason}>
					<ModalReason
						title={infoReasonComponent.titleModal}
						idReasonType={infoReasonComponent.idReasonType}
						closeModalReason={setOpenModalReason}
						infoReasonComponent={infoReasonComponent}
						handleSaveCustom={refreshGrid}
						handleUpdateQuoteCountStatus={refreshGrid}
						refreshRowByGuidProcurement={async () => refreshGrid()}
						setResultDataManageStatus={refreshGrid}
					/>
				</KogModalFadeComponent>
			)}
		</>
	);
}

export default OptionCancelPartSearchClaim;
